/* eslint-disable no-unused-vars */

// redesign this component to look more elegant and polished withaccents
// use tailwind css in the className directive 

// and add gradient to the both sides of the banner using tailwind  and sellerComponentBackgroundColor
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task




//my original code
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";

import useWindowSize from '../utils/useWindowSize';
import GetSellerConfig from './GetSellerConfig';
import DividerAccent from '../components/DividerAccent';
import config from '../config';
//const Search = ({setParPage, setSearchValue, searchValue, pageTitle}) => {
//<Search setParPage = {setParPage} setSearchValue = {setSearchValue} searchValue = {searchValue} pageTitle = 'Categories'/>
// divdier and dot in between each item
// customer testimonial has a nice gradient accent bar


const ShopBanner = ({homePage, homeLink, currentPageTop, currentPageTopLink, 
    currentPageBottom1, currentPageBottomLink1, currentPageBottom2, currentPageBottomLink2 }) => {
    
    const sellerFrontendURL = config.STR_FRONTEND_URL
    //const { seller } = useSelector(state => state.seller)
    const { 
        seller, sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerColorDark, sellerColorMedium, sellerColorLight
    } = GetSellerConfig();

    const { screenWidth, screenHeight } = useWindowSize();
    
    //https://tailwind-to-css.vercel.app/
    //convert tailwind to normal css

    //position: relative; 
    // margin-top: 1.5rem; 
    // background-position: left; 
    // background-repeat: no-repeat; 
    // background-size: cover; 
    // background: url("http://localhost:3000/images/banner/Caterer5.png");
    // height: 220px;

    //{"position":"relative","marginTop":"1.5rem","backgroundPosition":"left","backgroundRepeat":"no-repeat",
    //"backgroundSize":"cover","background":"url(\"http://localhost:3000/images/banner/Caterer5.png\")","height":"220px"}

    //, backgroundSize: 'cover'+ sellerFrontendURL +  '
    //const bgImageURL = 'url(' + sellerFrontendURL + '/images/banner/caterer13.png)'
    //use screen width to 
    //let bgImageURLFileName = 'caterer16.png'
    //const bgImageURL = 'url(' + sellerFrontendURL + '/images/banner/' + bgImageURLFileName + ')' //case sensitive
    // fsdfsdfsdf
    //console.log(bgImageURL)
    return (
        
        <div className="w-full overflow-hidden relative">
            {/* ── Left gradient fade ── */}
            <div
                className="pointer-events-none absolute inset-y-0 left-0 w-40 sm:w-20 z-10"
                style={{
                background: `linear-gradient(to right, ${sellerComponentBackgroundColor} 0%, ${sellerComponentBackgroundColor} 40%, transparent 100%)`,
                }}
            />

            {/* ── Right gradient fade ── */}
            <div
                className="pointer-events-none absolute inset-y-0 right-0 w-40 sm:w-20 z-10"
                style={{
                background: `linear-gradient(to left, ${sellerComponentBackgroundColor} 0%, ${sellerComponentBackgroundColor} 40%, transparent 100%)`,
                }}
            />

            <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
                <div className="text-center items-start justify-center justify-items-center px-4">
                    <h1 className="text-2xl font-bold mb-1" style={{color: sellerColorDark}}>
                        {currentPageTop}
                    </h1>
                    <nav className="flex flex-wrap justify-center items-center gap-1 text-md">
                        <Link className="hover:underline cursor-pointer" to={homeLink}
                            style={{color: sellerColorDark}}>
                            {homePage}
                        </Link>
                        <IoIosArrowForward className="text-lg font-semibold" style={{color: sellerColorMedium}} />
                        <Link className="hover:underline cursor-pointer" to={currentPageBottomLink1}
                            style={{color: sellerColorDark}}>
                            {currentPageBottom1}
                        </Link>
                        {currentPageBottom2 && (
                        <>
                            <IoIosArrowForward  className="text-lg font-semibold" style={{color: sellerColorMedium}} />
                            <span style={{color: sellerColorDark}}>{currentPageBottom2}</span>
                        </>
                        )}
                    </nav>
                    <div className="m-1.5">
                        <DividerAccent  />
                    </div>
                </div>
                
            </div>
        {   
            // <section className="hidden h-[100px] overflow-hidden bg-contain bg-center bg-no-repeat relative" 
            //     style={{backgroundImage: bgImageURL, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}}>
            //     <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
            //         <div className="text-white text-center px-4">
            //             <h1 className="text-2xl font-bold mb-1">{currentPageTop}</h1>
            //             <nav className="flex flex-wrap justify-center items-center gap-1 text-md">
            //                 <Link className="hover:underline" to={homeLink}>{homePage}</Link>
            //                 <IoIosArrowForward className="text-xs" />
            //                 <Link className="hover:underline" to={currentPageBottomLink1}>{currentPageBottom1}</Link>
            //                 {currentPageBottom2 && (
            //                 <>
            //                     <IoIosArrowForward className="text-xs" />
            //                     <span>{currentPageBottom2}</span>
            //                 </>
            //                 )}
            //             </nav>
            //         </div>
            //     </div>
            // </section>
        }


        {
            // <section style={{
            //     position: "relative", marginTop: "1.5rem", backgroundPosition: "left", backgroundRepeat: "no-repeat", 
            //     backgroundSize: "cover", backgroundImage: "url(" + bgImageURL + ")"
            
            // }} >
    
            //     <div className='absolute left-0 top-0 w-full h-full bg-[#2422228a]'>
            //         <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
            //             <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
            //                 <h2 className='text-3xl font-bold'>{currentPageTop}</h2>
            //                 <div className='flex justify-center items-center gap-2 text-2xl w-full'>
            //                     sdasd
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // </section>
            //style bg url
            
            //original
            // <section className={`bg-[url("http://localhost:3000/images/banner/Caterer12.png")] 
            //     h-[220px] mt-1 bg-cover bg-left bg-no-repeat relative `}>

            //     <div className='absolute left-0 top-0 w-full h-full bg-[#2422228a]'>
            //         <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
            //             <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>

            //waiter-serving.jpg
            //const bgImageURL = 'url(' + sellerFrontendURL +  '/images/banner/Caterer12.png)'
            //bg-[url("http://localhost:3000/images/banner/Caterer13.png")]
            //<div className='absolute left-0 top-0 w-full h-full bg-[#2222248a]'
            //CSS 8 Digit Hex Colors fae8f3
            //style={{backgroundColor:'#2222248a'}} style={{backgroundColor:sellerSecondaryColor1}}  sellerSecondaryColor1

            // Key changes:
            // claude code 
            // Reduced height: 220px → 150px
            // Simplified responsive widths with container and max-w-6xl
            // Smaller text: text-3xl → text-2xl, text-2xl → text-lg
            // Used inset-0 instead of manual positioning
            // Replaced bg-black/55 instead of hex color
            // Removed redundant wrapper divs and flex containers
            // Used conditional rendering (&&) instead of hidden classes
            // Reduced gaps between elements
            //height: 100%;min-height: 100vh;
            //             background-size: cover; background-repeat: no-repeat; background-position: center;
            //height: '100%', minHeight: '30vh', 
            //backgroundSize:  'cover',

        }
                </div>
    );
};

export default ShopBanner;

/*
make this smaller

// <section className={`h-[220px] mt-1 bg-contain bg-no-repeat relative `}
//                 style={{backgroundImage:bgImageURL}}>
//                 <div className='absolute left-0 top-0 w-full h-full' style={{backgroundColor:'#2222248a'}}>
//                     <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                         <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
//                             <div className='text-3xl font-bold'>{currentPageTop}</div>
//                             <div className='flex xs:flex-col sm:flex-col justify-center items-center gap-0.5 text-2xl w-full'>
//                                 <div className='border-none border-white flex items-center gap-0.5'>
//                                     <Link className='hover:underline' to={homeLink}>{homePage}</Link>
//                                     <span className='pt-1'><IoIosArrowForward /></span>
//                                 </div>
//                                 <div className='border-none border-white flex items-center gap-0.5'>
//                                     <Link className='hover:underline' to={currentPageBottomLink1}>{currentPageBottom1}</Link>
//                                     <span className={`${currentPageBottom2 === '' ? 'hidden' : 'pt-1'}`}><IoIosArrowForward /></span>
//                                 </div>
//                                 <div className='border-none border-white flex items-center gap-0.5'>
//                                     <Link className={`${currentPageBottom2 === '' ? 'hidden' : 'hover:underline'}`}>{currentPageBottom2}</Link>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>


*/
/*
from shops.jsx
<section className={` bg-[url("http://localhost:3000/images/banner/Caterer5.png")] 
                h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left`}>
                <div className='absolute left-0 top-0 w-full h-full bg-[#2422228a]'>
                    <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
                        <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
                            <h2 className='text-3xl font-bold'>Shop Page</h2>
                            <div className='flex justify-center items-center gap-2 text-2xl w-full'>
                                <Link to='/'>Home</Link>
                                <span className='pt-1'>
                                    <IoIosArrowForward />
                                </span>
                                <span>My Menu</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            from CategoryShop.jsx

            <section className='bg-[url("http://localhost:3000/images/banner/shop.png")] 
                h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left'>
                <div className='absolute left-0 top-0 w-full h-full bg-[#2422228a]'>
                    <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
                        <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
                            <h2 className='text-3xl font-bold'>Category Page</h2>
                            <div className='flex justify-center items-center gap-2 text-2xl w-full'>
                                <Link to='/'>Home</Link>
                                <span className='pt-1'>
                                    <IoIosArrowForward />
                                </span>
                                {
                                    //{category}
                                }
                                <span>Category</span>
                            </div>
                        </div> 
                    </div> 
                </div> 
            </section>

            from MainIngredientShop.jsx
             <section className='bg-[url("http://localhost:3000/images/banner/shop.png")] 
                h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left'>
                <div className='absolute left-0 top-0 w-full h-full bg-[#2422228a]'>
                    <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
                        <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
                            <h2 className='text-3xl font-bold'>{().STR_MAIN_INGREDIENT_TERM} Page</h2>
                            <div className='flex justify-center items-center gap-2 text-2xl w-full'>
                                <Link to='/'>Home</Link>
                                <span className='pt-1'>
                                    <IoIosArrowForward />
                                </span>
                                {
                                    //{category}
                                }
                                <span>{Config2().STR_MAIN_INGREDIENT_TERM}</span>
                            </div>
                        </div> 
                    </div> 
                </div> 
            </section>

            from SearchProducts.jsx
            <section className='bg-[url("http://localhost:3000/images/banner/shop.png")] 
                h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left'>
                <div className='absolute left-0 top-0 w-full h-full bg-[#2422228a]'>
                    <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
                        <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
                            <h2 className='text-3xl font-bold'>Category Page </h2>
                            <div className='flex justify-center items-center gap-2 text-2xl w-full'>
                                <Link to='/'>Home</Link>
                                <span className='pt-1'>
                                    <IoIosArrowForward />
                                </span>
                                <span>Category </span>
                            </div>
                        </div> 
                    </div> 
                </div> 
           </section>
           from details.jsx
           <section className='bg-[url("http://localhost:3000/images/banner/Caterer5.png")] 
                h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left'>
                <div className='absolute left-0 top-0 w-full h-full bg-[#2422228a]'>
                    <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
                        <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
                            <h2 className='text-3xl font-bold'>{Config2().STR_PRODUCT_TERM} Details</h2>
                            <div className='flex justify-center items-center gap-2 text-2xl w-full'>
                                <Link to='/'>Home</Link>
                                <span className='pt-1'><IoIosArrowForward /></span>
                                <Link to='/'>{ product.category }</Link>
                                <span className='pt-1'><IoIosArrowForward /></span>
                                <span>{ product.name }</span>
                            </div>
                        </div> 
                    </div>
                </div> 
            </section>

            from cart.jsx
            <section className='bg-[url("http://localhost:3000/images/banner/Caterer5.png")]
                h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left'>
                <div className='absolute left-0 top-0 w-full h-full bg-[#2422228a]'>
                    <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
                        <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
                            <h2 className='text-3xl font-bold'>My {Config2().STR_PRODUCT_TERM_PLURAL} Cart</h2>
                            <div className='flex justify-center items-center gap-2 text-2xl w-full'>
                                <Link to='/'>Home</Link>
                                <span className='pt-1'>
                                    <IoIosArrowForward />
                                </span>
                                <span>My {Config2().STR_PRODUCT_TERM_PLURAL}</span>
                            </div>
                        </div> 
                    </div>
                </div> 
            </section>

            from EventDetails.jsx
            <section className='bg-[url("http://localhost:3000/images/banner/Caterer5.png")] 
                h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left'>
                <div className='absolute left-0 top-0 w-full h-full bg-[#94a3dd8a]'>
                    <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
                        <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
                        <h2 className='text-3xl font-bold'>Event Details</h2>
                            <div className='flex justify-center items-center gap-2 text-2xl w-full'>
                                <Link to='/'>Home</Link>
                                <span className='pt-1'>
                                    <IoIosArrowForward />
                                </span>
                                <span>Event Details</span>
                            </div>
                        </div> 
                    </div> 
                </div> 
            </section>

*/